import { configureStore } from "@reduxjs/toolkit";
import headerSlice from "../features/common/headerSlice";
import modalSlice from "../features/common/modalSlice";
import nodesSlice from "../features/nodes/nodesSlice";
import orgSlice from "../features/settings/organization/orgSlice";
import querySlice from "../features/query/querySlice";
import userSlice from "../features/user/userSlice";

const combinedReducer = {
  header: headerSlice,
  modal: modalSlice,
  node: nodesSlice,
  org: orgSlice,
  query: querySlice,
  user: userSlice,
};

export default configureStore({
  reducer: combinedReducer,
});
